import classes from "./FieldDataC.module.css";
import {  Route, Routes } from "react-router-dom";


import Dashboard from "../Dashboard/Dashboard";

import TransportNew from "../DailyProd/RequisitionNew";

import Tranporter from "../DailyProd/RequisitionDetails";
import TranporterView from "../DailyProd/RequisitionView";

import JonwardInward from "../JobWorkInward/RequisitionDetails";
import JonwardInwardNew from "../JobWorkInward/RequisitionNew";
import JonwardInwardView from "../JobWorkInward/RequisitionView";

const FieldDataS = (fieldProps) => {
 
  return (
    <div className={classes["Fields"]}>
      <Routes>
        <Route path="/dashboard" element={<Dashboard />} />
      
        
        <Route
          path="/transection/job-work-inward"
          element={<JonwardInward />}
        />
        <Route
          path="/transaction/job-work-inward-new"
          element={<JonwardInwardNew />}
        />
        <Route
          path="/transaction/job-work-inward-view/:id"
          element={<JonwardInwardView />}
        />
        
       

        <Route path="/transaction/job-work-new" element={<TransportNew />} />
        
        <Route path="/transection/job-work" element={<Tranporter />} />
        <Route path="/transection/job-work-view/:id" element={<TranporterView />} />
        
      </Routes>
    </div>
  );
};

export default FieldDataS;
